module.exports = __webpack_public_path__ + "static/img/61001.93a673f6.png";